import axios from 'axios';
import { BeachData } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000, // Increase to 60 seconds for large dataset
});

export const getBeachesData = async (userLat: number, userLon: number, maxDistance: number = 500): Promise<BeachData[]> => {
  try {
    console.log('Making API request with params:', { userLat, userLon, maxDistance });
    const response = await apiClient.get('/beaches', {
      params: {
        user_lat: userLat,
        user_lon: userLon,
        max_distance: maxDistance,
        limit: 50,
      },
    });
    console.log('API response received:', response.data?.length, 'beaches');
    return response.data;
  } catch (error) {
    console.error('Error fetching beach data:', error);
    throw new Error(`Failed to fetch beach data: ${error instanceof Error ? error.message : 'Unknown error'}`);
  }
};

export const getUserLocation = (): Promise<GeolocationPosition> => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by this browser'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => resolve(position),
      (error) => reject(error),
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 300000, // 5 minutes
      }
    );
  });
};